import { identify, Identify } from '@amplitude/analytics-browser';
import { getEventOptions } from '../../utils';

type IdentityEvent = {
    userLocation: string;
    stateSelected: string;
};

export const sendAmplitudeIdentityEvent = ({ userLocation, stateSelected }: IdentityEvent) => {
    const options = getEventOptions();

    const identity = new Identify();
    identity.set('User Location', userLocation);
    identity.set('State Selected', stateSelected);

    identify(identity, options);
};
